import React from 'react';
import { Skeleton } from '@fourthwall/components';
export const ArticlesSkeleton = () => (React.createElement("div", null,
    React.createElement(Skeleton, { gap: 20 },
        React.createElement(Skeleton.Shape, { width: "100%", height: 190 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 190 }))));
